const LoadingSkeleton = ({ type = "list" }) => {
  const commonSkeleton = () => (
    <div className="flex flex-col my-10 mx-4 md:mx-8 xl:mx-32 animate-pulse">
      <div className="relative bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="relative h-[400px] w-full bg-gray-200" />
        <div className="p-8">
          <div className="h-8 bg-gray-200 rounded w-3/4 mb-4" />
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-8" />
          <div className="space-y-3">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-4/6" />
          </div>
        </div>
      </div>
    </div>
  );

  const cveDetailSkeleton = () => (
    <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto my-6 ">
      
      <div className="mt-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/2 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full mb-2" />
        <div className="h-4 bg-gray-200 rounded w-full mb-2" />
      </div>
      {[...Array(3)].map((_, index) => (
        <div className="mt-6 animate-pulse" key={index}>
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-2" />
        </div>
      ))}
    </div>
  );

  const cveListSkeleton = () => (
    <div className="flex flex-col my-10 md:my-20 xl:mx-32 md:mx-8 mx-4 gap-10">
      {[1, 2, 3].map((item) => (
        <div key={item} className="relative flex h-auto min-h-[10rem] border w-3/4 rounded-tr-3xl animate-pulse">
          
          <div className="flex flex-col gap-4 ml-10 py-2 w-full">
            <div className="h-6 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-1/4" />
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="h-4 bg-gray-200 rounded w-5/6" />
              <div className="h-4 bg-gray-200 rounded w-4/6" />
            </div>
          </div>
          <div className="absolute top-0 right-0 h-8 w-24 bg-gray-200 rounded-tr-xl" />
        </div>
      ))}
    </div>
  );

  switch (type) {
    case "detail":
      return commonSkeleton();
    case "cve-detail":
      return cveDetailSkeleton();
    case "cve-list":
      return cveListSkeleton();
    default:
      return cveListSkeleton(); // Fallback to list skeleton
  }
};

export default LoadingSkeleton;